import React, { useState } from 'react';

const navLinks = [
  { href: '#rooms', label: 'Rooms' },
  { href: '#amenities', label: 'Amenities' },
  { href: '#policies', label: 'Policies' },
  { href: '#location', label: 'Location' }
];

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 z-50 w-full border-b border-brand-border bg-brand-surface/95 backdrop-blur">
      <div className="mx-auto flex h-20 max-w-6xl items-center justify-between px-6 md:px-10">
        <a href="#home" className="font-heading text-2xl md:text-3xl text-brand-primary tracking-wide">
          Holiday Motel
        </a>

        <nav className="hidden items-center gap-7 md:flex" aria-label="Primary">
          {navLinks.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="text-sm font-semibold uppercase tracking-[0.08em] text-brand-muted transition-colors duration-300 hover:text-brand-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-accent"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <a href="tel:+17053251316" className="hidden md:inline-flex btn-primary !px-5 !py-2.5" aria-label="Call Holiday Motel">
          705-325-1316
        </a>

        <button
          type="button"
          className="inline-flex items-center justify-center rounded-full border border-brand-border p-2 text-brand-primary md:hidden"
          aria-label="Toggle navigation menu"
          aria-expanded={isMenuOpen}
          onClick={() => setIsMenuOpen((open) => !open)}
        >
          <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" d={isMenuOpen ? 'M6 18L18 6M6 6l12 12' : 'M4 6h16M4 12h16M4 18h16'} />
          </svg>
        </button>
      </div>

      {isMenuOpen ? (
        <div className="border-t border-brand-border bg-brand-surface px-6 pb-6 pt-4 md:hidden">
          <nav className="flex flex-col gap-2" aria-label="Mobile Primary">
            {navLinks.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="rounded-xl px-4 py-3 text-sm font-semibold uppercase tracking-[0.08em] text-brand-primary transition-colors duration-300 hover:bg-[#efe6d7]"
                onClick={() => setIsMenuOpen(false)}
              >
                {item.label}
              </a>
            ))}
            <a href="tel:+17053251316" className="btn-primary mt-3 text-center" onClick={() => setIsMenuOpen(false)}>
              Call 705-325-1316
            </a>
          </nav>
        </div>
      ) : null}
    </header>
  );
};

export default Header;
